import Analytics, { OptimisationInputEvent } from '@ecs-uk/web-common-analytics';

export const trackChangePaymentMethodAvailability = (isWebNewChangePaymentMethodEnabled: boolean) => {
  Analytics.publishOnce(
    OptimisationInputEvent.fromObject({
      testName: 'change_payment_method',
      testArea: 'Product Movement',
      testVariant: isWebNewChangePaymentMethodEnabled ? 'B' : 'A',
    })
  );
};

// Normalise payment method identifiers to match Snowplow schema expectations (snake_case)
const PAYMENT_METHOD_NORMALISATION: Record<string, string> = {
  applePay: 'apple_pay',
};

// Data 4.0 event to track the result of attempting to tokenize the payment method
export const trackPaymentMethodTokenizationResult = (successful: boolean, paymentMethod: string) => {
  Analytics.trackSelfDescribingEvent({
    schema: 'iglu:uk.co.experian.subscriptions/payment_method_tokenization_attempted/jsonschema/1-0-0',
    data: {
      successful,
      payment_method: PAYMENT_METHOD_NORMALISATION[paymentMethod] ?? paymentMethod,
      journey: 'change_payment_method',
    },
  });
};

// Data 4.0 event for when the output token is received from 3DS challenge
export const track3dsOutputTokenReceived = () => {
  Analytics.trackSelfDescribingEvent({
    schema: 'iglu:uk.co.experian.subscriptions/three_d_secure_output_token_received/jsonschema/1-0-0',
    data: {
      journey: 'change_payment_method',
    },
  });
};

// Data 4.0 event for when there is a failure in the 3DS challenge
export const track3dsChallengeFailure = (errorCode?: string, errorMessage?: string) => {
  Analytics.trackSelfDescribingEvent({
    schema: 'iglu:uk.co.experian.subscriptions/three_d_secure_failed/jsonschema/1-0-0',
    data: {
      journey: 'change_payment_method',
      error_code: errorCode ?? 'unknown',
      error_message: errorMessage ?? 'unknown',
    },
  });
};
